<template>
    <label class="fac-switch" :class="design">
        <div class="wrapper">
            <input
				:data-ui="dataUi"
                :id="id"
                :name="name"
                :checked="checked"
                type="checkbox"
                :disabled="disabled"
                @change="onChange"
                @click="onClick"
            />
            <div :for="id" class="switch" :class="{'disabled': disabled }">
                <span v-if="textOn">{{ textOn }}</span>
                <span v-if="textOff">{{ textOff }}</span>
            </div>
        </div>
        <div v-if="label" class="label" :style="{fontSize: fontSize}" v-html="label" />
    </label>
</template>

<script>
export default {
	name: 'ui-switch',
	props: {
		/**
		 * Referente ao id="" da tag input do switch.
		 */
		id: {
			type: String,
			required: false,
		},
		/**
		 * Texto que vem ao lado do switch.
		 */
		label: {
			type: String,
			required: false,
		},
		/**
		 * Referente ao name="" da tag input do switch.
		 */
		name: {
			type: String,
			required: false,
		},
		/**
		 * Recebe as classes CSS de moficação do componente.
		 */
		design: {
			type: String,
			required: false,
		},
		/**
		 * Descontinuada / Quebrada / Não utilizada.
		 */
		textOff: {
			type: String,
			required: false,
		},
		/**
		 * Descontinuada / Quebrada / Não utilizada.
		 */
		textOn: {
			type: String,
			required: false,
		},
		/**
		 * Estado inicial do componente.
		 */
		checked: {
			type: Boolean,
			required: false,
		},
		/**
		 * Desativa as funções do componente.
		 */
		disabled: {
			type: Boolean,
			required: false,
		},
		/**
		 * Valor que pode ser personalizado para retornar quando o switch está ligado.
		 */
		 valueTrue: {
			type: [String, Number, Boolean],
			required: false,
			default: true,
		},
		/**
		 * Valor que pode ser personalizado para retornar quando o switch está desligado.
		 */
		valueFalse: {
			type: [String, Number, Boolean],
			required: false,
			default: false,
		},
		fontSize: {
			type: String,
			default: '12px'
		},
		/**
		 * Define o data-ui do componente
		 */
		dataUi: {
			type: String,
			required: false,
			default: '',
		},
	},
	methods: {
		onClick(event) {
			this.$emit('click', event)
		},
		onChange(event) {
			const isChecked = event.target.checked;
			this.$emit('input', isChecked ? this.valueTrue : this.valueFalse);
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>